<div class="live-video-container" #videoContainer>
  <div id="rushDealerVideo" [attr.attr-stream-name]="streamName"></div>
</div>
